export function CNPJValidation(value) {
	if (!value) return false;

	const cnpj = value.replace(/[^0-9A-Za-z]+/g, "").toUpperCase();

	if (cnpj.length !== 14) return false;

	if (!/^\d{2}$/.test(cnpj.slice(12))) return false;

	if (/^(\d)\1{13}$/.test(cnpj)) return false;

	const charValue = char => char.charCodeAt(0) - 48;

	const calcDigit = base => {
		let soma = 0;
		let pos = base.length - 7;

		for (let i = base.length; i >= 1; i--) {
			soma += charValue(base.charAt(base.length - i)) * pos--;
			if (pos < 2) pos = 9;
		}

		return soma % 11 < 2 ? 0 : 11 - (soma % 11);
	};

	if (calcDigit(cnpj.substring(0, 12)) !== +cnpj.charAt(12)) return false;
	if (calcDigit(cnpj.substring(0, 13)) !== +cnpj.charAt(13)) return false;

	return true;
}

export function CPFValidation(value) {
	if (!value) return false;

	value = value
		.replace(".", "")
		.replace("-", "")
		.replace(" ", "");

	if (value.length !== 11) return false;

	var Soma;
	var Resto;
	Soma = 0;

	if (value === "00000000000") return false;

	for (let i = 1; i <= 9; i++)
		Soma = Soma + parseInt(value.substring(i - 1, i), 10) * (11 - i);
	Resto = (Soma * 10) % 11;

	if (Resto === 10 || Resto === 11) Resto = 0;
	if (Resto !== parseInt(value.substring(9, 10), 10)) return false;

	Soma = 0;
	for (let i = 1; i <= 10; i++)
		Soma = Soma + parseInt(value.substring(i - 1, i), 10) * (12 - i);
	Resto = (Soma * 10) % 11;

	if (Resto === 10 || Resto === 11) Resto = 0;
	if (Resto !== parseInt(value.substring(10, 11), 10)) return false;
	return true;
}

export const validateContractCode = value => {
	const regex = /^[^/]*$/;
	if (!value) {
		return "O campo é obrigatório";
	}
	if (!regex.test(value)) {
		return "O código do contrato não pode conter barras (/)";
	}
	return undefined;
};

export const validateContractURL = value => {
	if (!value) {
		return "O campo é obrigatório";
	}
	return undefined;
};
